import Perf from 'react-addons-perf';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import { Provider } from 'react-redux';
import { configureStore } from './store/configureStore';
import Root from './containers/_Root';

let store;
let rootDiv = document.getElementById('quickresponse');

function initApp() {
    ReactDOM.render(
        <Provider store={store}>
            <Root />
        </Provider>, rootDiv);
}

function init() {

    initReactPerf();

    if (rootDiv) {
        axios({
            method: 'get',
            url: rootDiv.getAttribute('data-url'),
            responseType: 'json',
        })
        .then(function (response) {
            store = configureStore(response.data);
            initApp();
        })
        .catch(function (response) {
            console.log(response);
        });
    }
}

function initReactPerf(){
    window.Perf = Perf;
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/quick_response/index.js